import { Suspense } from 'react';
import Spinner from 'Spinner';
import Form from './Form';
import { post } from 'axios';
import React from "react";
import config from '../../../config';

function NewReservation(props) {
  const reservationUrl = `${config.API_PATH}/reservation`;

  const save = async (data) => {
    try {
      const response = await post(`${reservationUrl}`, data);
      props.history.replace({
        pathname: `/reservation/${response.data.id}`,
        state: { created: true }
      });
      return response
    } catch (error) {
      return error;
    }
  };

  return (
    <>
      <Suspense fallback={<Spinner />}>
        <Form save={save} />
      </Suspense>
    </>
  );
}

export default NewReservation;
